import { TDropdown } from "../../shared/modal";

export type TVendorCpRecord = {
    id?: number;
    name: string;
    email: string;
    phoneNo: string;
    vendorCompanyId: number;
    vendorCompany: TDropdown;
    alternatePhoneNo?: string;
    cellNo?: string;
    status: boolean;
    majorTech?: string;
}

export const EmptyVendorCpRecord: TVendorCpRecord = {
    name: '',
    email: '',
    phoneNo: '',
    vendorCompanyId: 0,
    vendorCompany: { id: 0, name: '' },
    status: true,
}

export type TVendorCp = {
    id: number;
    name: string;
    email: string;
    phoneNo: string;
    vendorCompanyId: number;
    vendorCompanyName: string;
    alternatePhoneNo?: string;
    cellNo?: string;
    status: boolean;
    majorTech?: string;
}